import * as React from "react";
import { List, Datagrid, TextField, EmailField, DateField, Edit, SimpleForm, TextInput, Create, BooleanInput, BooleanField } from 'react-admin';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    booleanLabel: {
        '& .MuiFormControlLabel-label': { whiteSpace: 'nowrap' },
    },
});

const UserTitle = props => {
    return <span>{props.record ? `${props.record.name}` : ''}</span>;
};

export const UserList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="first_name" />
            <TextField source="last_name" />
            <EmailField source="email" />
            <BooleanField source="new_timesheet_notification" label="Timesheet notifications" sortable={false} />
            <DateField source="created_at" />
            <DateField source="updated_at" />
        </Datagrid>
    </List>
);

export const UserEdit = props => {
    const classes = useStyles();
    const transform = (data) => {
        delete data.registration_confirmation_token;
        delete data.name;
        return data;
    };

    return (<Edit {...props} title={<UserTitle />} transform={transform}>
        <SimpleForm>
            <TextInput source="first_name" />
            <TextInput source="last_name" />
            <TextInput source="phone_number" />
            <TextInput source="email" />
            <BooleanInput source="new_timesheet_notification" label="New timesheet email notifications" className={classes.booleanLabel} />
        </SimpleForm>
    </Edit>)
};

export const UserCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="first_name" />
            <TextInput source="last_name" />
            <TextInput source="phone_number" />
            <TextInput source="email" />
        </SimpleForm>
    </Create>
);
